import React, {useEffect, useState} from "react";
import {Typography, Box, makeStyles, Grid, Link, Divider} from "@material-ui/core";
import {hexToRgb} from "../../../common/theme";
import {useCustomerCare} from "../../../hooks/useCustomerCare";
import {useI18N} from "../../../common/common";
import {Skeleton} from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    mb05: {
        marginBottom: theme.spacing(0.5)
    },
    mb1: {
        marginBottom: theme.spacing(1)
    },
    mb2: {
        marginBottom: theme.spacing(2)
    },
    mb3: {
        marginBottom: theme.spacing(3)
    },
    subtitleDetails: {
        marginBottom: theme.spacing(5),
        color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textHigh)
    },
    telephoneLink: {
        color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textHigh),
        ...theme.typography.infoMessage,
        "&:hover": {
            textDecoration: "none"
        }
    },
    divider: {
        border: "1px solid " + theme.palette.borders.line.light,
        marginBottom: theme.spacing(3)
    },
    sticky: {
        position: "sticky",
        top: 0,
        backgroundColor: theme.palette.background.default,
        zIndex: 1,
    }
}));

const CallUsGeneralContactDetails = () => {
    const classes = useStyles();
    const {i18n} = useI18N();
    const {componentData, loading} = useCustomerCare();
    const [items, setItems] = useState();
    const [roamingFeesDisclaimer, setRoamingFeesDisclaimer] = useState();

    useEffect(() => {
        if (componentData && !loading) {
            setItems(componentData);
            setRoamingFeesDisclaimer(componentData?.[0]?.extraParameters?.[0]);
        }
    }, [componentData]);

    return (
        <Box
            align="center"
        >
            <Box
                className={classes.sticky}
            >
                <Typography
                    variant="h3"
                    className={classes.mb2}
                >
                    {loading ? <Skeleton /> : items?.[0]?.title}
                </Typography>
                <Typography
                    className={classes.subtitleDetails}
                >
                    {loading ? <Skeleton /> : items?.[0]?.subtitle}
                </Typography>
            </Box>

            <Grid
                container
                direction="column"
            >
                {items?.[0]?.elementsCollection?.items?.map((item, index) => {
                    return (
                        <Grid
                            item
                            key={item?.phone}
                        >
                            {item?.companyName && (
                                <Typography
                                    variant="subtitle2"
                                    className={classes.mb05}
                                >
                                    {loading ? <Skeleton /> : item?.companyName}
                                </Typography>
                            )}

                            {item?.streetPostalCodeCityCountry && (
                                <Typography
                                    variant="body2"
                                    className={classes.mb3}
                                >
                                    {loading ? <Skeleton /> : item?.streetPostalCodeCityCountry}
                                </Typography>
                            )}

                            {item?.serviceNumber &&
                                <Box>
                                    <Link
                                        href={`tel:${item?.serviceNumber}`}
                                        className={classes.telephoneLink}
                                    >
                                        {loading ? <Skeleton /> : item?.serviceNumber}
                                    </Link>
                                </Box>
                            }

                            {item?.phone &&
                                < Box
                                    mt={1}
                                >
                                    <Link
                                        href={`tel:${item?.phone}`}
                                        className={classes.telephoneLink}
                                    >
                                        {loading ? <Skeleton /> : item?.phone}
                                    </Link>
                                </Box>
                            }

                            {item?.localNumber &&
                                <Box
                                    mt={1}
                                >
                                    <Link
                                        href={`tel:${item?.localNumber}`}
                                        className={classes.telephoneLink}
                                    >
                                        {loading ? <Skeleton /> : item?.localNumber}
                                    </Link>
                                </Box>
                            }

                            <Box mt={3}>
                                <Typography
                                    variant="body2"
                                >
                                    {i18n("dialog.contact.calls_us.resort.calling_hours")}
                                </Typography>

                                {item?.workingHours && (
                                    <Box
                                        mb={3}
                                    >
                                        <Typography
                                            variant="body2"
                                        >
                                            {item?.workingHours.split(",")[0]}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                        >
                                            {loading ? <Skeleton /> : item?.workingHours?.split(",")[1]}
                                        </Typography>
                                    </Box>
                                )}

                                {index !== items.length + 1 &&
                                <Divider className={classes.divider} />
                                }
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>

            {roamingFeesDisclaimer && (
                <Typography
                    variant="body2"
                >
                    {loading ? <Skeleton /> : roamingFeesDisclaimer}
                </Typography>
            )}

        </Box >
    );
};

export default CallUsGeneralContactDetails;
